import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ServiceTemplateScheduleOccurrenceRow } from "../serviceTemplateScheduleOccurrencesViewConfig";
import {
    formatServiceTemplateScheduleOccurrenceDate,
    formatServiceTemplateScheduleOccurrenceDayOfWeek,
} from "../formatServiceTemplateScheduleOccurrenceDate";

export const ServiceTemplateScheduleOccurrenceDateCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        ServiceTemplateScheduleOccurrenceRow,
        string
    >) => {
        const value = getValue();

        if (!value) {
            return (
                <ViewTableCell>
                    <span>-</span>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <Tooltip
                    content={formatServiceTemplateScheduleOccurrenceDayOfWeek(
                        value,
                    )}
                >
                    <span tabIndex={0}>
                        {formatServiceTemplateScheduleOccurrenceDate(value)}
                    </span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);

ServiceTemplateScheduleOccurrenceDateCell.displayName =
    "ServiceTemplateScheduleOccurrenceDateCell";
